import { TopBar } from "@/components/layout";
import HostingsTable from "@/components/HostingsTable";

const HostingsPage = () => {
  return (
    <>
      <TopBar title="Hostingi" />
      <div className="flex-1 overflow-auto p-6">
        <HostingsTable />
      </div>
    </>
  );
};

export default HostingsPage;
